import React, { useState } from 'react';
import { Row, Col, Card, Modal, ListGroup, Pagination, Spinner } from 'react-bootstrap';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { getAdsByCity } from '../../services/UserServices/UserService';

const ListingDistribution = ({ location, renderScrollableLegend }) => {
  // --- State Management ---
  const [showModal, setShowModal] = useState(false);
  const [selectedCity, setSelectedCity] = useState(null);
  const [flats, setFlats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  // Pagination State
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);

  // --- API Call Simulation ---
  const fetchFlats = async (cityName, page) => {
    setLoading(true);
    
    try {
   

      const response = await getAdsByCity(page-1, 10, cityName);
        
       
      setFlats(response?.data?.data?.ads);
      console.log("pie chrt",response?.data?.data?.ads)
      setTotalCount(response?.data?.data?.total)
      setTotalPages( Math.ceil(response?.data?.data?.total/10))

    } catch (error) {
      console.error("Error fetching flats:", error);
    } finally {
      setLoading(false);
    }
  };

  // --- Event Handlers ---
  const handleLegendClick = (data) => {
    // Recharts Legend onClick passes an object where 'value' is the label name (e.g., "Chandigarh")
    // If your data structure is different, you might need data.payload.name instead
    const cityName = data.value; 
     console.log("city name",cityName)
    if (cityName) {
      setSelectedCity(cityName);
      setCurrentPage(1);
      setShowModal(true);
      fetchFlats(cityName, 1);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFlats([]);
    setTotalCount(0)
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    fetchFlats(selectedCity, pageNumber);
  };

  return (
    <>
      <Row>
        <Col md={12} className="mb-4">
          <Card className="p-4 shadow-sm border-0 rounded-4 h-100">
            <h5 style={{ fontSize: "1.2rem" }} className="mb-4">Listing Distribution by Location</h5>
            {Array.isArray(location) && location.length > 0 ? (
              <ResponsiveContainer width="100%" height={250}>
                <PieChart>
                  <Pie
                    data={location}
                    cx="35%"
                    cy="50%"
                    innerRadius={60}
                    outerRadius={95}
                    paddingAngle={2}
                    dataKey="value"
                    // REMOVED onClick from here
                  >
                    {location.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend
                    content={renderScrollableLegend}
                    layout="vertical"
                    verticalAlign="middle"
                    align="right"
                    wrapperStyle={{ width: '55%', right: 0, cursor: 'pointer' }}
                    onClick={handleLegendClick} // ADDED onClick here
                  />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <div className="d-flex align-items-center justify-content-center" style={{ height: "250px", color: "#6B7280", fontWeight: "500" }}>
                No data available for the selected filter
              </div>
            )}
          </Card>
        </Col>
      </Row>

      {/* --- Flats List Modal --- */}
      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Available Flats in {selectedCity}(Total Flats : {totalCount})</Modal.Title>
        </Modal.Header>
        
        <Modal.Body style={{ minHeight: '300px' }}>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center h-100">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : flats.length > 0 ? (
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <ListGroup variant="flush">
              {flats.map((flat, index) => {
                  // Calculate Serial Number dynamically across pages
                  const serialNumber = (currentPage - 1) * 10 + (index + 1);
                  
                  return (
                    <ListGroup.Item key={flat._id} className="d-flex align-items-center py-3">
                    
                      <div 
                        className="d-flex justify-content-center align-items-center text-muted fw-bold me-3 rounded-circle bg-light"
                        style={{ width: '32px', height: '32px', fontSize: '14px', flexShrink: 0 }}
                      >
                        {serialNumber}
                      </div>
                      
                      {/* Title & Info */}
                      <div className="flex-grow-1">
                        <h6 className="mb-1">{flat.title}</h6>
                        <small className="text-muted">Pincode: {  flat.pinCode}</small>
                      </div>
                      
                      {/* Price Badge */}
                      <span className="badge bg-success rounded-pill ms-2">{flat.price}</span>
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </div>
          ) : (
            <p className="text-center text-muted mt-4">No flats found for this location.</p>
          )}
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <Pagination className="mb-0">
            <Pagination.Prev 
              disabled={currentPage === 1 || loading} 
              onClick={() => handlePageChange(currentPage - 1)} 
            />
            {[...Array(totalPages)].map((_, idx) => (
              <Pagination.Item 
                key={idx + 1} 
                active={idx + 1 === currentPage}
                disabled={loading}
                onClick={() => handlePageChange(idx + 1)}
              >
                {idx + 1}
              </Pagination.Item>
            ))}
            <Pagination.Next 
              disabled={currentPage === totalPages || loading} 
              onClick={() => handlePageChange(currentPage + 1)} 
            />
          </Pagination>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ListingDistribution;